import {Grid as AntGrid} from "antd";

export const Grid = AntGrid;
export default Grid;
